module.exports = __webpack_public_path__ + "img/state.ba5840eb.png";